import { useEffect, useState } from 'react';

export const usePreloadImages = (offers) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!offers || offers.length === 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    let loadedCount = 0;
    const total = offers.length;
    let isCancelled = false;

    const handleLoad = () => {
      loadedCount += 1;
      if (loadedCount === total && !isCancelled) {
        setLoading(false);
      }
    };

    offers.forEach((offer) => {
      const img = new Image();
      img.src = offer.offer_image;
      img.onload = handleLoad;
      img.onerror = handleLoad;
    });
    return () => {
      isCancelled = true;
    };
  }, [offers]);

  return loading;
};
